query GetLegalEntities {
  legalEntities {
    id
    name
    currencies
    salesforceName
    sageId
  }
}
